import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.scss']
})
export class ProjectCreateComponent implements OnInit {
   @ViewChild('vform') validationForm: FormGroup;
  projectForm:FormGroup;

  projectFormSubmitted:boolean=false;
  categories=[]
  selectedValue:''
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService:ApiService,
    private route:Router) { }

  ngOnInit(): void {
    this.getCategoriesList()
    this.projectForm=this.formBuilder.group({
    Pname: ['', Validators.required],
    category: ['', Validators.required]
  })

  }
  getCategoryId(event:any){
    this.selectedValue=event.target.value
    console.log('select category id',this.selectedValue)
  }
  getCategoriesList(){
    this.apiService.getAllCategory(1,100).subscribe((res:any)=>{
      console.log('categories list res',res)
      this.categories=res.data.items
    })
   }
  get rf() {
    return this.projectForm.controls;
  }
  submitProject(){
    let body={
      Pname:this.projectForm.controls.Pname.value,
      category:this.selectedValue,    
     }
     console.log('form value',body)
  
     this.apiService.createProjectList(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log('create-project',res)
         this.toastr.success(res.message)
       this.projectFormSubmitted = true;
       this.route.navigate(['/project/project-list']) 
      }  
      else{this.toastr.error(res.error)}        
     })
     this.projectFormSubmitted = true;
     if (this.projectForm.invalid) {
       return;
     }

  }
back(){
this.route.navigate(['/project/project-list'])
}
}
